import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Message from '../message/message';
import { getVersion } from '../../services/versionService';
import { setVersion } from '../../store/slices/configSlice';


const VersionCheck = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    // const [version, setVersion] = useState('');
    const [intervalInSeconds, setIntervalInSeconds] = useState('');
    const intervalRef = useRef(null);
    
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    // const REACT_APP_VERSION = import.meta.env.VITE_APP_VERSION;

    const checkVersion = async () => {
        try {
            let REACT_APP_VERSION = '1.0.0';
            const storedVersion = localStorage.getItem('appVersion');
            let versionVar = '';

            await getVersion()
                .then(rsp => {
                    console.log('🔍 Verificando versión...', new Date().toLocaleTimeString());
                    versionVar = rsp.metadata.version;
                    // setVersion(rsp.metadata.version);
                    dispatch(setVersion(rsp.metadata.version));
                    setIntervalInSeconds(rsp.metadata.interval);
                })
                .catch( error => {
                    // setVersion('1.0.0')
                    // setIntervalInSeconds(86400*1000)
                    console.log(error);
                })
                .finally(() => {
                    if (storedVersion !== null && storedVersion !== undefined 
                            && storedVersion !== 'null' && storedVersion !== 'undefined' 
                            && (storedVersion !== versionVar)) {
                        console.log('🔄 Nueva versión detectada!');
                        localStorage.setItem('appVersion', versionVar);
                        setOpen(true);
                    }
                    else if (!storedVersion) {
                        // Primera vez - guardar versión actual
                        localStorage.setItem('appVersion', versionVar);
                    }
                })
        }
        catch (error) {
            console.warn('Error checking version:', error);
        }
    };

    useEffect(() => {
        // Verificar inmediatamente al cargar
        checkVersion();


        getVersion()
            .then(rsp => {
                // setVersion(rsp.metadata.version);
                dispatch(setVersion(rsp.metadata.version));
                setIntervalInSeconds(rsp.metadata.interval);
                intervalRef.current = setInterval(checkVersion, rsp.metadata.interval * 1000);
            })
            .catch( error => {
                // setVersion('1.0.0');
                // setIntervalInSeconds(86400*1000);
                // intervalRef.current = setInterval(checkVersion, 86400*1000);
                console.log(error);
            });

        // Limpiar intervalo cuando el componente se desmonte
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []); // Dependencias
    


    useEffect(() => {
        if (intervalInSeconds > 0)
        {
            // Limpiar el intervalo anterior
            if (intervalRef.current) {
                console.log('🧹 Limpiando intervalo anterior:', intervalRef.current);
                clearInterval(intervalRef.current);
                intervalRef.current = null; // ← IMPORTANTE: resetear la referencia
            }
            
            // Crear nuevo intervalo
            intervalRef.current = setInterval(checkVersion, intervalInSeconds * 1000);
            console.log('🔄 Nuevo intervalo configurado:', intervalInSeconds * 1000, 'ms');
        }
    }, [intervalInSeconds]);



    const onCloseMessage = () => {
        setOpen(false);
        window.location.reload();
    }

    return (
        <>
            <Message 
                title={t("util.messageTitle")} 
                content={t("util.newVersionMessage")} 
                open={open} 
                onClose={() => onCloseMessage()} />
        </>
    );
};

export default VersionCheck;




// import { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Message from '../message/message';

// const VersionCheck = () => {
//     const REACT_APP_VERSION = import.meta.env.VITE_APP_VERSION;
//     const REACT_APP_BUILD_DATE = import.meta.env.VITE_APP_BUILD_DATE;
    
//     const [open, setOpen] = useState(false);
    
//     //TRANSLATION
//     const [t, i18n] = useTranslation("global");

//     useEffect(() => {
//         try {
//             const storedVersion = localStorage.getItem('appVersion');
//             if (storedVersion !== null && storedVersion !== undefined 
//                     && storedVersion !== 'null' && storedVersion !== 'undefined' 
//                     && (storedVersion !== REACT_APP_VERSION)) {
//                 localStorage.setItem('appVersion', REACT_APP_VERSION);
//                 localStorage.setItem('appBuildDate', REACT_APP_BUILD_DATE);
//                 setOpen(true);
//             }
//             else{
//                 localStorage.setItem('appVersion', REACT_APP_VERSION);
//             }
//         }
//         catch (error) {
//             console.warn('Error checking version:', error);
//         }
//     }, []);


//     const onCloseMessage = () => {
//         setOpen(false);
//         window.location.reload();
//     }


//     return (
//         <>
//             <Message 
//                 title={t("util.messageTitle")} 
//                 content={t("util.newVersionMessage")} 
//                 open={open} 
//                 onClose={()=>onCloseMessage()} />
//         </>
//     );
// };

// export default VersionCheck;